import { Component, Input, OnInit, signal, ViewEncapsulation, Inject, PLATFORM_ID  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CARD_TYPES } from '../../../core/constants/card.constants';
import { CardType } from '../../../core/models/card.types';
import { BUTTON_CLASS_TYPES } from '@constants/app-button.constants';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-title-banner',
  standalone: true,
  imports: [],
  templateUrl: './title-banner.html',
  styleUrls: ['./title-banner.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TitleBanner implements OnInit {
  @Input() title!: string;
  @Input() titleClass!: string;
  @Input() contentClass!: string;
  @Input() description!: string;
  @Input() aspect?: CardType = CARD_TYPES.PRIMARY;

  svgContent = signal<SafeHtml | null>(null);

  protected readonly BUTTON_CLASS_TYPES = BUTTON_CLASS_TYPES;

  protected readonly styleClass = signal(
    'bg-brand-primary border-0 rounded-[30px] h-full relative z-10 flex justify-between items-center'
  );

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (this.aspect === CARD_TYPES.TERTIARY) {
      this.styleClass.set(
        'bg-white border-0 rounded-[30px] h-full relative z-10 flex justify-between items-center'
      );
    }

    if (this.aspect === CARD_TYPES.SECONDARY) {
      this.styleClass.set(
        'bg-brand-secondary border-0 rounded-[30px] h-full relative z-10 flex justify-between items-center'
      );
    }
  }
}

